import classNames from 'classnames';
import type { ReactNode } from 'react';

export interface HeadlineFieldData {
  children: ReactNode;
  tag: HeadlineTag;
  style?: HeadlineTag;
  className?: string;
}

export enum HeadlineTag {
  H1 = 'h1',
  H2 = 'h2',
  H3 = 'h3',
  H4 = 'h4',
}

const HeadlineField: React.FC<HeadlineFieldData> = (data) => {
  const style = data.style ?? data.tag;
  let headlineClass = '';
  const CustomTag = data.tag;

  switch (style) {
    case HeadlineTag.H1:
      headlineClass = 'font-headline-1';
      break;
    case HeadlineTag.H2:
      headlineClass = 'font-headline-2';
      break;
    case HeadlineTag.H3:
      headlineClass = 'font-headline-3';
      break;
    case HeadlineTag.H4:
      headlineClass = 'font-headline-4';
      break;
  }

  return <CustomTag className={classNames('headline', headlineClass, data.className)}>{data.children}</CustomTag>;
};

export default HeadlineField;
